module.exports = __webpack_public_path__ + "static/media/386.871c9a19.svg";